import { useState, useEffect } from "react";
import {
  Grid,
  Typography,
  Paper,
  RadioGroup,
  FormControlLabel,
  Radio,
  Button,
  Box,
  CircularProgress,
} from "@mui/material";
import PersonalityQuiz1 from "../../../assets/SAP-Dashboard/PersonalityQuiz/PersonalityQuiz1.png";
import PersonalityQuiz2 from "../../../assets/SAP-Dashboard/PersonalityQuiz/personalityQuiz2.png";
import PersonalityQuiz3 from "../../../assets/SAP-Dashboard/PersonalityQuiz/personalityQuiz3.png";
import { questionsPQApi } from "../../api/personalityQuizApi";
import { useNavigate } from "react-router-dom";
import RocketModal from "../../components/Modal/RocketModal";
import { authFetch } from "../../../api";

export default function QuizMainLayout() {
  const [questions, setQuestions] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [answer, setAnswer] = useState("");
  const [loading, setLoading] = useState(true);
  const [openModal, setOpenModal] = useState(false);
  const [answers, setAnswers] = useState([]);
  const [resultMessage, setResultMessage] = useState("");
  const [currentImage, setCurrentImage] = useState(0);
  const images = [PersonalityQuiz1, PersonalityQuiz2, PersonalityQuiz3];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage((prev) => (prev + 1) % images.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const navigate = useNavigate();

  const fetchQuestions = async () => {
    try {
      const res = await questionsPQApi();
      if (res.data.success) {
        setQuestions(res.data.data);
      }
    } catch (error) {
      console.error("Error fetching questions:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchQuestions();
  }, []);

  const FinalResponse = async (finalAnswers) => {
    const userId = localStorage.getItem("userId");
    if (!userId) {
      console.error("No userId found in localStorage");
      return;
    }

    try {
      const res = await authFetch("quiz/update-question-answers", {
        method: "POST",
        body: JSON.stringify({ data: finalAnswers, user_id: userId }),
        headers: { "Content-Type": "application/json" },
      });

      const resultData = await res.json();
      if (
        !resultData.success &&
        resultData.message === "User have already submitted answers."
      ) {
        // store message
        localStorage.setItem("quizMessage", resultData.message);

        setResultMessage(resultData.message);
        setOpenModal(true);
        return;
      }

      if (resultData.success) {
        const result = resultData.data?.[0];

        const message = result?.category || "STEM Explorer";
        const description = result?.description || message;

        // ✅ store both values
        localStorage.setItem("quizMessage", message);
        localStorage.setItem("quizDescription", description);

        setResultMessage(description);
        setOpenModal(true);
      }
    } catch (error) {
      console.error("Error submitting quiz:", error);
      setResultMessage("Error submitting quiz. Try again later.");
      setOpenModal(true);
    }
  };

  const handleNext = () => {
    if (!answer) return;

    const updatedAnswers = [...answers];

    const selectedAnswer = currentQ.answers.find(
      (a) => a.id.toString() === answer,
    );

    const currentQData = {
      quesId: currentQ.id,
      ansId: Number(answer),
      category: selectedAnswer?.category,
    };

    updatedAnswers[currentIndex] = currentQData;
    setAnswers(updatedAnswers);

    if (currentIndex < questions.length - 1) {
      setCurrentIndex(currentIndex + 1);
      setAnswer(updatedAnswers[currentIndex + 1]?.ansId?.toString() || "");
    } else {
      FinalResponse(updatedAnswers);
    }
  };

  const handlePrev = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
      setAnswer(answers[currentIndex - 1] || "");
    }
  };

  if (loading) {
    return (
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
      >
        <CircularProgress />
      </Grid>
    );
  }

  if (!questions.length) {
    return (
      <Typography variant="h6" align="center" mt={5}>
        No questions available
      </Typography>
    );
  }

  const currentQ = questions[currentIndex];

  return (
    <Grid
      container
      sx={{ minHeight: "100vh", position: "relative", overflowX: "hidden" }}
    >
      <RocketModal
        open={openModal}
        onClose={() => setOpenModal(false)}
        message={resultMessage}
      />

      {/* Left Section */}
      <Grid
        item
        xs={12}
        md={4}
        sx={{
          backgroundColor: "#572575",
          display: "flex",
          alignItems: "center",
          justifyContent: { xs: "center", md: "flex-end" },
          p: { xs: 2, md: 4 },
          position: "relative",
          zIndex: 2,
        }}
      >
        <Box
          component="img"
          key={currentImage}
          src={images[currentImage]}
          alt="Personality Quiz"
          sx={{
            width: "100%",
            maxWidth: { xs: "220px", sm: "280px", md: "320px", lg: "350px" },
            borderRadius: "16px",
            position: "relative",
            zIndex: 3,
            right: { xs: 0, sm: "-5%", md: "-20%", lg: "-35%" },
            transition: "opacity 1s ease-in-out",
            opacity: 1,
          }}
        />
      </Grid>

      {/* Right Section */}
      <Grid
        item
        xs={12}
        md={8}
        sx={{
          backgroundColor: "#FDFDFD",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          p: { xs: 2, sm: 3, md: 6 },
          position: "relative",
          zIndex: 1,
        }}
      >
        <Grid container direction="column" xs={12} md={10} lg={8}>
          {/* Heading + Subheading */}
          <Grid sx={{ mt: { xs: 2, sm: 2, md: -4 }, mb: 2 }}>
            <Typography
              sx={{
                fontWeight: 400,
                lineHeight: 1.3,
                fontSize: { xs: "22px", sm: "28px", md: "38px", lg: "42px" },
                fontFamily: "Inter",
                color: "#313439",
                textAlign: { xs: "center", md: "left" },
                mb: 2,
              }}
            >
              Let’s know the something interesting{" "}
              <span style={{ color: "#9D0385" }}>About You!</span>
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontFamily: "Inter",
                color: "#3F424C",
                fontSize: { xs: "14px", sm: "16px", md: "18px" },
                textAlign: { xs: "center", md: "left" },
              }}
            >
              Discover your interests, personality, and what makes you stand out
              & tell us. What’s one quirky thing most people don’t know about
              you.
            </Typography>
          </Grid>

          {/* Question Card */}
          <Paper
            elevation={3}
            sx={{
              mt: "2",
              borderRadius: "16px",
              p: { xs: 2, sm: 3, md: 3 },
              maxWidth: "100%",
              mx: "auto",
            }}
          >
            <Typography
              variant="h6"
              sx={{
                fontFamily: "Inter",
                fontWeight: 400,
                mb: 2,
                fontSize: { xs: "16px", sm: "18px", md: "22px", lg: "24px" },
                color: "#161719",
                textAlign: { xs: "center", md: "left" },
              }}
            >
              {currentQ.questions}
            </Typography>

            <RadioGroup
              value={answer}
              onChange={(e) => setAnswer(e.target.value)}
            >
              {currentQ.answers.map((opt) => (
                <FormControlLabel
                  key={opt.id}
                  value={opt.id.toString()}
                  control={<Radio />}
                  label={opt.answers}
                  sx={{
                    alignItems: "flex-start",
                    ".MuiTypography-root": {
                      fontSize: {
                        xs: "14px",
                        sm: "16px",
                        md: "20px",
                        lg: "20px",
                      },
                      mt: { xs: "8px", sm: "18px", md: "8px" },
                      color: "#3F424C",
                      fontFamily: "Inter",
                      fontWeight: "400",
                    },
                  }}
                />
              ))}
            </RadioGroup>

            {/* Buttons */}
            <Grid container justifyContent="flex-end" mt={2} spacing={2}>
              {currentIndex > 0 && (
                <Grid item>
                  <Button
                    variant="outlined"
                    onClick={handlePrev}
                    sx={{
                      borderRadius: "16px",
                      px: { xs: 3, md: 4 },
                      textTransform: "none",
                      fontSize: { xs: "12px", sm: "14px", md: "16px" },
                      fontFamily: "Inter",
                      fontWeight: "700",
                      borderColor: "#3B035E",
                      color: "#3B035E",
                      "&:hover": {
                        borderColor: "#3B035E",
                        backgroundColor: "transparent",
                      },
                    }}
                  >
                    Back
                  </Button>
                </Grid>
              )}

              <Grid item>
                <Button
                  variant="contained"
                  onClick={handleNext}
                  sx={{
                    backgroundColor: "#3B035E",
                    borderRadius: "16px",
                    px: { xs: 3, md: 4 },
                    textTransform: "none",
                    fontSize: { xs: "12px", sm: "14px", md: "16px" },
                    fontFamily: "Inter",
                    fontWeight: "700",
                    "&:hover": {
                      backgroundColor: "#3B035E",
                    },
                  }}
                >
                  {currentIndex < questions.length - 1 ? "Next" : "Submit"}
                </Button>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </Grid>
    </Grid>
  );
}
